import React from "react";
import RecipientSection from "./components/RecipientSection";
import GoodsEditor from "./components/GoodsEditor";
import { Check, Field } from "./components/Fields";
import PremiumNotice from "./components/PremiumNotice";

export default function ReviewForm({
  draft,
  config,
  options = {},
  dictionaryChoices = [],
  dictionaryAccess,
  documents,
  onChange,
  onShowSource,
  disabled,
}) {
  const set = (field, value) => onChange({ ...draft, [field]: value });
  return (
    <fieldset disabled={disabled}>
      <section className="card premium-panel">
        <h2>1. Eksporter</h2>
        <p style={{ whiteSpace: "pre-line" }}>{config.exporter}</p>
        <p className="small text-muted">
          Dane z ustawień firmy. Zmianę eksportera ustala administrator przed
          utworzeniem zlecenia.
        </p>
      </section>
      <RecipientSection
        recipient={draft.recipient}
        candidates={draft.recipientCandidates}
        roles={options.recipientRoles}
        dictionaryChoices={dictionaryChoices}
        dictionaryAccess={dictionaryAccess}
        disabled={disabled}
        onChange={(value) => set("recipient", value)}
        onShowSource={onShowSource}
      />
      <section className="card premium-panel">
        <h2>3–5. Pochodzenie, transport i uwagi</h2>
        <Field
          label="Kraj pochodzenia"
          value={draft.countriesOfOrigin ?? ""}
          maxLength={2000}
          onChange={(event) => set("countriesOfOrigin", event.target.value)}
        />
        <div className="premium-grid">
          {(options.fields || []).map((field) => (
            <Field
              key={field.key}
              label={field.label}
              value={draft[field.key]}
              onChange={(event) => set(field.key, event.target.value)}
            />
          ))}
        </div>
        <Field
          label={options.remarksLabel || "Dodatkowe uwagi"}
          multiline
          value={draft.remarks}
          onChange={(event) => set("remarks", event.target.value)}
        />
        <p className="small text-muted">{options.remarksHint}</p>
      </section>
      <GoodsEditor
        items={draft.items}
        grossWeight={draft.grossWeight}
        options={options}
        documents={documents}
        setItems={(value) => set("items", value)}
        onWeightChange={(value) => set("grossWeight", value)}
        onShowSource={onShowSource}
      />
      <section className="card premium-panel">
        <h2>Sprawdzenie dokumentów</h2>
        {draft.sourceWarnings?.length > 0 && (
          <PremiumNotice warning>
            <strong>Uwagi odczytu (nie blokują wystawienia):</strong>
            <ul>
              {draft.sourceWarnings.map((warning, index) => (
                <li key={index}>{warning}</li>
              ))}
            </ul>
          </PremiumNotice>
        )}
        <Field
          label="Notatka z weryfikacji i korekt (opcjonalnie)"
          multiline
          value={draft.reviewNote}
          onChange={(event) => set("reviewNote", event.target.value)}
        />
        <Check
          label="Oznacz komplet dokumentów jako sprawdzony (opcjonalnie)."
          checked={draft.sourcesChecked}
          onChange={(event) => set("sourcesChecked", event.target.checked)}
        />
      </section>
    </fieldset>
  );
}
